export function collectNestedDocuments(folders = []) {
  let allDocs = [];
  for (const folder of folders) {
    if (folder.documents) {
      allDocs = allDocs.concat(folder.documents);
    }
    if (folder.subfolders) {
      allDocs = allDocs.concat(collectNestedDocuments(folder.subfolders));
    }
  }
  return allDocs;
}

function isValidFolder(folder) {
  return folder && typeof folder === 'object';
}

function findInDocuments(documents, docId) {
  const safeDocs = Array.isArray(documents) ? documents : [];
  return safeDocs.find(doc => doc?.unique_id === docId) || null;
}

function getSubfolders(folder) {
  return Array.isArray(folder.folders) ? folder.folders : folder.subfolders || [];
}

export function findDocumentById(tree, docId) {
  if (!tree || !docId) return null;

  const folders = Array.isArray(tree) ? tree : [tree];

  for (const folder of folders) {
    if (!isValidFolder(folder)) continue;

    const foundDoc = findInDocuments(folder.documents, docId);
    if (foundDoc) return foundDoc;

    const subfolders = getSubfolders(folder);
    const foundInSub = findDocumentById(subfolders, docId);
    if (foundInSub) return foundInSub;
  }

  return null;
}
